<script setup>
import { computed, ref, watch } from 'vue'
import tooltip from '@/vue/directives/tooltip'
import { useEmailEventsStore } from '@/stores/emailEvents'

// Register directive for local template usage
const vTooltip = tooltip

const props = defineProps({
    item: Object,
    value: String
})

const emailEventsStore = useEmailEventsStore()

const allEvents = ref(null)

const items = computed(() => {
    if (!props.value) return []

    const result = []
    const addresses = props.value.split(',')

    addresses.forEach((address) => {
        let cleanAddress = address
        if (cleanAddress.indexOf('<') > -1) {
            cleanAddress = cleanAddress.split('<')[1].split('>')[0]
        }

        const currentItem = {
            address: cleanAddress
        }

        if (allEvents.value) {
            currentItem.event = allEvents.value.find(o => o.recipient === cleanAddress)?.event
        }

        currentItem.status = currentItem.event ? currentItem.event.toUpperCase() : 'Unknown'

        result.push(currentItem)
    })

    return result
})

watch(() => props.item?.id, async (newId) => {
    if (!newId) {
        allEvents.value = null
        return
    }
    allEvents.value = await emailEventsStore.get(newId)
}, { immediate: true })

const getClass = (event) => {
    if (!event) {
        return 'bg-light'
    }

    const labels = {
        accepted: 'bg-warning',
        rejected: 'bg-danger',
        delivered: 'bg-success',
        failed: 'bg-danger',
        opened: 'bg-success',
        clicked: 'bg-success',
        unsubscribed: 'bg-danger',
        complained: 'bg-danger',
        stored: 'bg-warning'
    }

    if (event && Object.prototype.hasOwnProperty.call(labels, event)) {
        return labels[event]
    }
    return ''
}
</script>

<template>
    <div>
        <div v-for="(item, idx) in items" :key="idx" class="text-nowrap d-flex align-items-center">
            <span v-tooltip :class="getClass(item.event)" :title="'Delivery status: ' + item.status"
                  class="me-2 d-inline-block rounded-circle p-2" data-placement="right"/>

            {{ item.address }}
        </div>
    </div>
</template>

<style scoped>
span {
    min-width: 16px;
}
</style>